// DebugClerk.js
import { useUser } from '@clerk/clerk-react';

export const DebugClerk = () => {
  const { isLoaded, isSignedIn } = useUser();
  
  if (isLoaded) {
    console.log('🔍 Clerk Debug:', { isLoaded, isSignedIn });
  }
  
  return <div style={{display: 'none'}}>Clerk Debug</div>;
};